import { usePage, router } from "@inertiajs/react"
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { List, Kanban, Map } from "lucide-react"

type Props = {
  baseUrl: string
}

export function ViewModeToggle({ baseUrl }: Props) {
  const { url } = usePage()
  const currentPath = url.split("?")[0]
  const currentMode = currentPath.endsWith("/kanban")
    ? "kanban"
    : currentPath.endsWith("/carte")
      ? "carte"
      : "list"

  return (
    <Tabs
      value={currentMode}
      onValueChange={(value) => {
        const href =
          value === "kanban"
            ? `${baseUrl}/kanban`
            : value === "carte"
              ? `${baseUrl}/carte`
              : baseUrl
        router.visit(href, { preserveState: true })
      }}
    >
      <TabsList>
        <TabsTrigger value="list" className="cursor-pointer">
          <List className="size-4" />
          Liste
        </TabsTrigger>
        <TabsTrigger value="kanban" className="cursor-pointer">
          <Kanban className="size-4" />
          Kanban
        </TabsTrigger>
        <TabsTrigger value="carte" className="cursor-pointer">
          <Map className="size-4" />
          Carte
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
